import { render } from "./VesCalendar.vue?vue&type=template&id=b46d0b86&scoped=true"
import script from "./VesCalendar.vue?vue&type=script&lang=js"
export * from "./VesCalendar.vue?vue&type=script&lang=js"

import "./VesCalendar.vue?vue&type=style&index=0&id=b46d0b86&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b46d0b86"]])

export default __exports__